/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ListMcpTools200
} from './model/listMcpTools200.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List available MCP tools
 */
export const listMcpTools = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListMcpTools200>(
      {url: `/mcp/tools`, method: 'GET', signal
    },
      options);
    }




export const getListMcpToolsQueryKey = () => {
    return [
    `/mcp/tools`
    ] as const;
    }


export const getListMcpToolsQueryOptions = <TData = Awaited<ReturnType<typeof listMcpTools>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMcpTools>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMcpToolsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMcpTools>>> = ({ signal }) => listMcpTools(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMcpTools>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMcpToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listMcpTools>>>
export type ListMcpToolsQueryError = unknown


/**
 * @summary List available MCP tools
 */

export function useListMcpTools<TData = Awaited<ReturnType<typeof listMcpTools>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMcpTools>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMcpToolsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






